/**
 * Interface para a resposta de previsões de lugares do Google Maps
 */
export interface IAutocompleteResponse {
  suggestions: [
    {
      placePrediction: IPlacePrediction; // Lista de previsões de lugares
    }
  ]
}

export interface IPlacePrediction {
  place: string; // Identificador do lugar
  placeId: string; // ID do lugar
  text: IPlaceText; // Texto do lugar com possíveis correspondências
}

export interface IPlaceText {
  text: string; // Texto do lugar
}
